import { VeiculoModel } from "@/models/cadastros/assistencia/veiculo/VeiculoModel";
import LocalidadeModel from "@/models/cadastros/assistencia/geolocalizacao/LocalidadeModel";
import { QuestionarioModel } from "../QuestionarioModel";
import ServicoSubClienteModel  from '@/models/cadastros/assistencia/ServicoSubClienteModel';
import ClienteAdministrativoModel from "@/models/cadastros/assistencia/ClienteAdministrativoModel";

export class QuestionarioTrocaPneuModel implements QuestionarioModel {
  idServico?: number;
  veiculoPertenceAoAssociado: boolean;
  veiculo: VeiculoModel;
  localizacao: LocalidadeModel;
  veiculoEmLocalFechado: boolean;
  veiculoEmSubsolo: boolean;
  nomeContatoNoLocal?: string;
  telefoneContatoNoLocal?: string;
  servicoSubCliente?: ServicoSubClienteModel;
  possuiFerramenta?: boolean;
  clienteAdministrativo?: ClienteAdministrativoModel;
  constructor(
    veiculoPertenceAoAssociado: boolean,
    veiculo: VeiculoModel,
    localizacao: LocalidadeModel,
    veiculoEmLocalFechado: boolean,
    veiculoEmSubsolo: boolean,
    nomeContatoNoLocal?: string,
    telefoneContatoNoLocal?: string,
    servicoSubCliente?: ServicoSubClienteModel,
    possuiFerramenta?: boolean,
    clienteAdministrativo?: ClienteAdministrativoModel,
  ) {
    this.veiculoPertenceAoAssociado = veiculoPertenceAoAssociado;
    this.veiculo = veiculo;
    this.localizacao = localizacao;
    this.veiculoEmLocalFechado = veiculoEmLocalFechado;
    this.veiculoEmSubsolo = veiculoEmSubsolo;
    this.nomeContatoNoLocal = nomeContatoNoLocal;
    this.telefoneContatoNoLocal = telefoneContatoNoLocal;
    this.servicoSubCliente = servicoSubCliente;
    this.possuiFerramenta = possuiFerramenta;
    this.clienteAdministrativo = clienteAdministrativo;
  }
}
